export default "__VITE_ASSET__CyewrTAJ__"